import React from "react";
import PropTypes from "prop-types";

const FlipCard = props => {
  const [active, setActive] = React.useState(false);
  // Destructuring props
  const { title, frontImage, desc, tech, demo, code } = props;

  let btnDemoClassName;
  let btnCodeClassName;
  // if there is a prop (demo/code) do... else "none"
  demo ? (btnDemoClassName = "btn-demo") : (btnDemoClassName = "none");
  code ? (btnCodeClassName = "btn-code") : (btnCodeClassName = "none");

  return (
    <div className="flex-item">
      <h3>{title}</h3>
      <div
        onClick={() => {
          setActive(!active);
        }}
        className="flip-card"
      >
        <div className={"flip-card-inner " + (active && "flip-the-card")}>
          <div className="flip-card-front text-center">{frontImage}</div>
          <div className="flip-card-back">
            <h3>{desc}</h3>
            <p>
              <span className="span">Built with: </span>
              {tech}
            </p>
          </div>
        </div>
      </div>
      {/* Buttons */}
      <a href={demo} target="_blank" rel="noreferrer">
        <button className={btnDemoClassName}>Demo</button>
      </a>
      <a href={code} target="_blank" rel="noreferrer">
        <button className={btnCodeClassName}>Code</button>
      </a>
    </div>
  );
};

FlipCard.propTypes = {
  title: PropTypes.string,
  frontImage: PropTypes.element,
  desc: PropTypes.string,
  tech: PropTypes.string,
  // buttons
  demo: PropTypes.string,
  code: PropTypes.string,
};

export default FlipCard;
